/* eslint-disable */
import React, { useEffect, useState } from "react";
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOGEVENT, MODULE } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { EditPageHeader } from "../../components/EditPageHeader";
import { toast } from 'react-toastify';
import { useTranslation } from "../../locale/useTranslation";
import BossDialog from "../../components/BossDialog";
import { utility } from "../../framework/utility/utilityProvider";
import { ImageBrowser } from "../../framework/forms/helpercomponents/selectFile/ImageBrowser";

const NodeEditForm = (props) => {

    const { item = {}, refresh, cancelEdit } = props;

    const blankDataItem = {
        ...item,
        SID: item.SID ?? 0,
        Name: item.copy ? "Copy of " + item.Name : item.Name ?? "",
        ImageGroup: item?.ImageGroup ?? {},
        ImageUrl: item?.ImageUrl ?? "",
        ParentalRating: item?.ParentalRating ?? {},
        ExternalReference: item?.ExternalReference ?? "",
        Archive: item?.Archive ?? false,
        DisplayTitle: item?.DisplayTitle ?? "",
        TranslatedDisplayTitle: item?.TranslatedDisplayTitle ?? "",
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [parentNodes, setParentNodes] = useState([]);
    const [parentNode, setParentNode] = useState({});
    const [imageGroups, setImageGroups] = useState([]);
    const [imageSelected, setImageSelected] = useState(false);
    const [catalogues, setCatalogues] = useState([]);
    const [parentalrating, setParentalRating] = useState([]);
    const [availableNodes, setAvailableNodes] = useState([]);
    const lang = useTranslation();

    useEffect(() => {
        loadCombo();
    }, [])

useEffect(() => {
    if (item?._id) return;
    if (!dataItem?.Catalogue?._id || availableNodes.length === 0) return;

    const rootNode = parentNodes[0] || { _id: null, SID: Math.random(), Archive: false, Name: "root", parentNode: null };;

    const filteredParents = availableNodes.filter(node => node?.Catalogue?._id === dataItem?.Catalogue?._id);

    setParentNodes([rootNode, ...filteredParents]);
    setParentNode(rootNode);

}, [dataItem.Catalogue, availableNodes]);


    const loadCombo = async () => {
        let catalougeRes = await API.getDataLookup(ENTITYNAME.Catalogues, { sort: { Description: 1 }, query: ['Archive', '!=', true] });
        setCatalogues(catalougeRes.data);
        let imagegroupRes = await API.getDataLookup(ENTITYNAME.ImageGroups, { sort: { Name: 1 }, query: ['Archive', '!=', true] });
        setImageGroups(imagegroupRes.data);
        let parentalratingRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 }, query: ['Archive', '!=', true] });
        setParentalRating(parentalratingRes.data);

        if (item?.SID == 0) {
            setDataItem({
                ...dataItem, ImageGroup: utility.getDefaultItem(imagegroupRes.data),
                ImageGroup: item?.ImageGroup && Object.keys(item?.ImageGroup).length > 0 ? item?.ImageGroup : utility.getDefaultItem(imagegroupRes.data), 
                Catalogue: item?.Catalogue && Object.keys(item?.Catalogue).length > 0 ? item?.Catalogue : utility.getDefaultItem(catalougeRes.data)
            })
        } 
        // else {
        //     setDataItem({
        //         ...dataItem, Language: item?.Language && Object.keys(item?.Language).length > 0 ? item?.Language : utility.getDefaultItem(languagesRes.data),
        //         ImageGroup: item?.ImageGroup && Object.keys(item?.ImageGroup).length > 0 ? item?.ImageGroup : utility.getDefaultItem(imagegroupRes.data),
        //         Catalogue: item?.Catalogue && Object.keys(item?.Catalogue).length > 0 ? item?.Catalogue : utility.getDefaultItem(catalougeRes.data)
        //     });
        // }
        let parentRes = await API.getDataLookup(ENTITYNAME.Nodes);
        if (parentRes.success) {
            const nullItem = { _id: null, SID: Math.random(), Archive: false, Name: "root", parentNode: null };
            setParentNodes([nullItem]);
            setAvailableNodes(parentRes.data);
            if (item?.SID == 0) {
                setParentNode(nullItem);
            }
            if (item.copy || item.SID > 0 || item?.ParentNode) {
                const filteredParents = parentRes.data.filter(x => x?.Catalogue?._id == item?.Catalogue?._id);
                setParentNodes([nullItem, ...filteredParents]);
                setParentNode(item.ParentNode == null ? nullItem : parentRes.data.find(x => x._id == item.ParentNode));
            }
        } else {
            toast.error(parentRes.message);
        }
    };

    const onChange = (e) => {
        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        }
        else if (e.target.name === "Catalogue") {
            const selectedCatalogue = e.target.value;
            setDataItem({ ...dataItem, Catalogue: selectedCatalogue });
            const rootNode = parentNodes[0];

            if (!selectedCatalogue || !selectedCatalogue._id) {
                setParentNodes([rootNode]);
                setParentNode(rootNode);
                return;
            }
            const filteredParents = availableNodes.filter(
                node => node?.Catalogue?._id === selectedCatalogue._id
            );
            setParentNode(rootNode);
            setParentNodes([rootNode, ...filteredParents]);
            return;
        }
        else if (e.target.name == "parentNode") {
            setParentNode(e.target.value);
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    };

    const isValid = () => {
        if (!dataItem.Name || dataItem.Name == "") {
            toast.error(lang.please_enter_name_error_message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }
        if (!dataItem.DisplayTitle || dataItem.DisplayTitle == "") {
            toast.error(lang.please_enter_display_title_error_message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }
        if (!dataItem.TranslatedDisplayTitle || dataItem.TranslatedDisplayTitle == "") {
            toast.error(lang.please_enter_translated_display_title_error_message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }
        if (!dataItem.Catalogue || Object.keys(dataItem.Catalogue).length == 0) {
            toast.error(lang.please_select_catalogue_error_message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false
        }
        if (!parentNode || Object.keys(parentNode).length == 0) {
            toast.error(lang.please_select_parent_error_message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false
        }
        if (!dataItem.ParentalRating || Object.keys(dataItem.ParentalRating).length == 0) {
            toast.error(lang.please_select_parent_rating_error_message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }
        if (!dataItem.ExternalReference || dataItem.ExternalReference == "") {
            toast.error(lang.please_enter_external_refrence_error_message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false
        }
        if (!dataItem.ImageGroup || Object.keys(dataItem.ImageGroup).length == 0) {
            toast.error(lang.please_select_image_group_error_message, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false
        }
        return true;
    }

    const handleSubmit = async () => {

        if (!isValid()) return;

        const saveData = {
            _id: !item?.copy ? dataItem._id : null,
            SID: !item?.copy ? dataItem.SID ?? 0 : 0,
            Name: dataItem.Name ?? "",
            Catalogue: dataItem.Catalogue && Object.keys(dataItem.Catalogue).length > 0 ? {
                _id: dataItem.Catalogue._id,
                Description: dataItem.Catalogue.Description
            } : {},
            ImageUrl: dataItem.ImageUrl ?? "",
            ImageGroup: dataItem.ImageGroup && Object.keys(dataItem.ImageGroup).length > 0 ? {
                _id: dataItem.ImageGroup._id,
                Name: dataItem.ImageGroup.Name
            } : {},
            ParentalRating: dataItem.ParentalRating && Object.keys(dataItem.ParentalRating).length > 0 ?
                {
                    _id: dataItem.ParentalRating._id,
                    Description: dataItem.ParentalRating.Description
                } : {},
            ExternalReference: dataItem.ExternalReference ?? "",
            ParentNode: parentNode?._id ?? null,
            Archive: dataItem.Archive ?? false,
            checkDuplicate: true,
            DisplayTitle: dataItem.DisplayTitle ?? "",
            TranslatedDisplayTitle: dataItem.TranslatedDisplayTitle ?? "",
            query: [[" Name", "=", dataItem.Name], ["Language._id", "=", dataItem?.Language?._id]],
        }
        console.log(saveData);
        let res = await API.saveData(ENTITYNAME.Nodes, saveData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.NODES, data: res.data, message: res.message };
            API.SaveLogs(logData);
            utility.deleteLocalStorageItem(ENTITYNAME.Nodes);
            cancelEdit();
            refresh();
        } else {
            toast.error(
                <div>
                    <strong>INVALID</strong>
                    <div style={{ fontSize: '10px' }}>{res.message}</div>
                </div>,
                { position: toast.POSITION.TOP_RIGHT }
            );
        }
    }

    return (
        <>
            <BossDialog
                title={item?._id ? item?.Name : lang.create_node_dialog_header}
                onClose={props.cancelEdit}
                width="720px"
            >
                <div className="row align-items-center">
                    <div className="col" >
                        <EditPageHeader
                            onSubmit={handleSubmit}
                            onCancel={props.cancelEdit}
                            showTitle={false}
                        />
                    </div>
                    {item?.SID > 0 && (
                        <div className="col-auto d-flex align-items-center">
                            <label className="mb-0 mr-2">{lang.sid_label}:</label>
                            <input
                                name="SID"
                                type="text"
                                className="form-control form-control-sm"
                                value={dataItem.SID}
                                disabled
                                style={{ width: "120px" }}
                            />
                        </div>
                    )}
                </div>
                <div className="row mt-2">
                    <div className="col-12">
                        <label>{lang.name_label} *</label>
                        <input
                            name={"Name"}
                            type="text"
                            className="form-control form-control-sm"
                            onChange={onChange}
                            value={dataItem.Name}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-6">
                    <label>{lang.display_title_label} *</label>
                        <input
                            name={"DisplayTitle"}
                            type="text"
                            className="form-control form-control-sm"
                            onChange={onChange}
                            value={dataItem.DisplayTitle}
                        />
                    </div>
                    <div className="col-6">
                        <label>{lang.translated_display_title_label} *</label>
                        <input
                            name={"TranslatedDisplayTitle"}
                            type="text"
                            className="form-control form-control-sm"
                            onChange={onChange}
                            value={dataItem.TranslatedDisplayTitle}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-6">
                        <label>{lang.catalogue_label} *</label>
                        <DropDownList
                            data={catalogues}
                            name={"Catalogue"}
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.Catalogue}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6">
                        <label>{lang.vod_channel_label} *</label>
                        <DropDownList
                            data={parentNodes}
                            name={"parentNode"}
                            textField="Name"
                            dataItemKey="_id"
                            value={parentNode}
                            onChange={onChange}
                        />
                        <p className="list-unstyled blockquote-footer">{lang.note_for_parent_select_root_label}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <label>{lang.parental_rating_label} *</label>
                        <DropDownList
                            name="ParentalRating"
                            data={parentalrating}
                            textField="Description"
                            dataItemKey="_id"
                            value={dataItem.ParentalRating}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6">
                        <label>{lang.external_refrence_label} *</label>
                        <input
                            name={"ExternalReference"}
                            type="text"
                            className="form-control form-control-sm"
                            onChange={onChange}
                            value={dataItem.ExternalReference}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-6">
                        <label>{lang.image_group_label} *</label>
                        <DropDownList
                            data={imageGroups}
                            name={"ImageGroup"}
                            textField="Name"
                            dataItemKey="_id"
                            value={dataItem.ImageGroup}
                            onChange={onChange}
                        />
                    </div>
                    <div className="col-6">
                        <label>{lang.image_url_label} </label>
                        <ImageBrowser name={'ImageUrl'} value={dataItem.ImageUrl} onChange={onChange} setImageSelected={setImageSelected} hidePosterLibrary={true} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 mt-4">
                        <input
                            type="checkbox"
                            name="Archive"
                            value={dataItem.Archive}
                            checked={dataItem.Archive}
                            onChange={onChange}
                        />
                        <label htmlFor="TabView" className="pl-1">{lang.archive}</label>
                    </div>
                </div>

            </BossDialog>
        </>)
};

export default NodeEditForm;